/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiServerExceptionResponse,
  MagicToken,
  MagicTokenAnonymousRequest,
  MagicTokenRequest,
  MagicTokenResponse,
} from '../models/index';
import {
    ApiServerExceptionResponseFromJSON,
    ApiServerExceptionResponseToJSON,
    MagicTokenFromJSON,
    MagicTokenToJSON,
    MagicTokenAnonymousRequestFromJSON,
    MagicTokenAnonymousRequestToJSON,
    MagicTokenRequestFromJSON,
    MagicTokenRequestToJSON,
    MagicTokenResponseFromJSON,
    MagicTokenResponseToJSON,
} from '../models/index';

export interface MagicTokenApiConsumeRequest {
    id: string;
}

export interface MagicTokenApiCreateRequest {
    magicTokenRequest: MagicTokenRequest;
}

export interface MagicTokenApiExchangeRequest {
    token: string;
}

export interface MagicTokenApiGetRequest {
    id: string;
}

export interface MagicTokenApiRequestNewTokenRequest {
    magicTokenAnonymousRequest: MagicTokenAnonymousRequest;
}

/**
 * 
 */
export class MagicTokenApi extends runtime.BaseAPI {

    /**
     * Afterwards the token is no longer valid. This does NOT authenticate a User, set a cookie nor create a session.
     * Marks a Magic token as used/consumed.
     */
    async consumeRaw(requestParameters: MagicTokenApiConsumeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MagicToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling consume().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/magic-token/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MagicTokenFromJSON(jsonValue));
    }

    /**
     * Afterwards the token is no longer valid. This does NOT authenticate a User, set a cookie nor create a session.
     * Marks a Magic token as used/consumed.
     */
    async consume(requestParameters: MagicTokenApiConsumeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MagicToken> {
        const response = await this.consumeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *          Create a new Magic Token.         This endpoint is used for API (authenticated) users.         For unauthenticated users, use the /email (requestNewToken) endpoint.     
     */
    async createRaw(requestParameters: MagicTokenApiCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MagicToken>> {
        if (requestParameters['magicTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'magicTokenRequest',
                'Required parameter "magicTokenRequest" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/magic-token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MagicTokenRequestToJSON(requestParameters['magicTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MagicTokenFromJSON(jsonValue));
    }

    /**
     *          Create a new Magic Token.         This endpoint is used for API (authenticated) users.         For unauthenticated users, use the /email (requestNewToken) endpoint.     
     */
    async create(requestParameters: MagicTokenApiCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MagicToken> {
        const response = await this.createRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exchange a magic token for an authenticated cookie (and redirect if possible).
     */
    async exchangeRaw(requestParameters: MagicTokenApiExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling exchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/auth/magic-token/{token}`;
        urlPath = urlPath.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Exchange a magic token for an authenticated cookie (and redirect if possible).
     */
    async exchange(requestParameters: MagicTokenApiExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exchangeRaw(requestParameters, initOverrides);
    }

    /**
     * Return a MagicToken by its ID, without the actual token.
     */
    async getRaw(requestParameters: MagicTokenApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MagicToken>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/magic-token/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MagicTokenFromJSON(jsonValue));
    }

    /**
     * Return a MagicToken by its ID, without the actual token.
     */
    async get(requestParameters: MagicTokenApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MagicToken> {
        const response = await this.getRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all MagicToken defined for this user, without the actual token.
     */
    async getAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/magic-token`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Return all MagicToken defined for this user, without the actual token.
     */
    async getAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllRaw(initOverrides);
    }

    /**
     * This does NOT authenticate a User, set a cookie nor create a session.
     * Request a Magic Token via e-mail.
     */
    async requestNewTokenRaw(requestParameters: MagicTokenApiRequestNewTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MagicTokenResponse>> {
        if (requestParameters['magicTokenAnonymousRequest'] == null) {
            throw new runtime.RequiredError(
                'magicTokenAnonymousRequest',
                'Required parameter "magicTokenAnonymousRequest" was null or undefined when calling requestNewToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/magic-token/email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MagicTokenAnonymousRequestToJSON(requestParameters['magicTokenAnonymousRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MagicTokenResponseFromJSON(jsonValue));
    }

    /**
     * This does NOT authenticate a User, set a cookie nor create a session.
     * Request a Magic Token via e-mail.
     */
    async requestNewToken(requestParameters: MagicTokenApiRequestNewTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MagicTokenResponse> {
        const response = await this.requestNewTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
